export const classes = {
  text: 'font-normal text-grey-6 inline',
};
